import React, { useEffect, useState } from 'react'
import { View, Linking, StyleSheet } from 'react-native'
import { GiftedChat, Send } from 'react-web-gifted-chat'
import Icon from 'react-native-vector-icons/dist/FontAwesome'
import AppContainer from './AppContainer'
import AppMain from './AppMain'
import categories from './categories'
import {
  getUserDataUserId, getUserDataMessages, setUserDataMessages
} from './user-data'
import axios from 'axios'
import { subColor } from './_variables.scss'
// locale指定を有効にするのに必要
import 'moment/locale/ja'

const generateMessage = (text, user, additionalData) => (
  {
    id: Math.round(Math.random() * 1000000),
    createdAt: new Date(),
    text,
    user,
    ...additionalData,
  }
)

// 保存用データを取得(ダミーメッセージを除外)
const getSaveData = (messages) => messages.filter(({ dummy }) => !dummy)

const renderSend = (props) => (
  <Send {...props}>
    <View>
      <Icon name="send" size={20} color={subColor} style={{ marginBottom: 16, marginHorizontal: 4 }} />
    </View>
  </Send>
)

const ChatInner = ({ id, category }) => {
  const botUser = category && Object.assign({ id }, category.botUser)
  const guideMessages = category.guideTexts
        .map((text) => generateMessage(text, botUser, { dummy: true }))
        .reverse()
  const [messages, setMessages] = useState([
    ...guideMessages,
    ...getUserDataMessages(id),
  ])
  const userId = getUserDataUserId()

  // 最新メッセージへのスクロール
  let chatRef = React.createRef()
  useEffect(() => {
    const { current } = chatRef
    if (current) {
      const { _messageContainerRef } = current
      _messageContainerRef && _messageContainerRef.scrollToFirstMessage()
    }
  }, [messages, chatRef])

  return (
    <AppContainer headerOptions={{ title: category.name }}>
      <AppMain style={styles.main}>
        <View style={styles.container1}>
          <View style={styles.container2}>
            <GiftedChat
              ref={chatRef}
              user={{ id: userId }}
              messages={messages}
              multiline={false}
              showAvatarForEveryMessage={true}
              renderAvatarOnTop={true}
              parsePatterns={() => [
                // 電話番号
                // * ParsedText内の正規表現では日本の電話番号にマッチしないため、ここで定義
                {
                  pattern: /\d{2,5}[-‐(]\d{1,4}[-‐)]\d{4}/,
                  style: { textDecorationLine: 'underline' },
                  onPress: (props) => {
                    const url = `tel:${props.replace(/\D/g, '')}`
                    Linking.canOpenURL(url)
                      .then((supported) => {
                        if (supported) {
                          Linking.openURL(url)
                        } else {
                          console.error('No handler for URL:', url)
                        }
                      })
                  },
                },
              ]}
              locale='ja'
              placeholder="質問を入力してください"
              renderSend={renderSend}
              onSend={(newMessages) => {
                // ユーザーの入力メッセージを追加
                setMessages((state) => {
                  const messages = [...newMessages, ...state]
                  setUserDataMessages(id, getSaveData(messages))
                  return messages
                })

                // botと通信
                newMessages.forEach(({ text }) => {
                  const params = {
                    userid: userId,
                    botclass: id,
                    text,
                  }
                  axios
                    .post('https://katsushika-data.kokosil.net/chatbot/cgi/chat.cgi', JSON.stringify(params))
                    .then(({ data }) => {
                      // botの応答を追加
                      if ('output' in data) {
                        const { text } = data.output
                        setMessages((state) => {
                          const messages = [generateMessage(text, botUser), ...state]
                          setUserDataMessages(id, getSaveData(messages))
                          return messages
                        })
                      }
                    })
                    .catch((error) => {
                      // TODO: エラーが発生しました
                      console.error(error)
                    })
                })
              }}
            />
          </View>
        </View>
      </AppMain>
    </AppContainer>
  )
}

const Chat = ({ history, match: { params: { id } } }) => {
  const category = categories[id]
  if (!category) {
    history.goBack()
    return null
  }

  return <ChatInner {...{ id, category }} />
}

const styles = StyleSheet.create({
  main: {
    // 期待通りのスクロール動作を得るにはmaxHeightが必要
    maxHeight: '100vh',
  },
  container1: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    height: "100vh",
  },
  container2: {
    display: "flex",
    flex: 3,
    flexDirection: "column",
  },
})

export default Chat
